module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-stone-path-background-remnants.4e104d18.png";